var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('Container',{ref:"container"},[_c('i',{staticClass:"f-icon tc-g3",staticStyle:{"font-size":"2.5rem"}},[_vm._v("")]),_c('div',{staticClass:"ta-c pa-a ma-t"},[_vm._v("\n      请联系平台管理员开通该板块权限。\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }